import styled, { css } from 'styled-components';
var checkboxSize = '20px';
var CheckboxList = styled.div.withConfig({
  displayName: "Checkboxstyles__CheckboxList",
  componentId: "b61uwr-0"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:50px;font-family:", ";font-weight:", ";"], function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.weight.regular;
});
var FieldSet = styled.fieldset.withConfig({
  displayName: "Checkboxstyles__FieldSet",
  componentId: "b61uwr-1"
})(["border:none;display:flex;flex-direction:column;align-items:center;width:100%;overflow:hidden;"]);
var ContentContainer = styled.div.withConfig({
  displayName: "Checkboxstyles__ContentContainer",
  componentId: "b61uwr-2"
})(["width:100%;"]);
var CheckboxOption = styled.div.withConfig({
  displayName: "Checkboxstyles__CheckboxOption",
  componentId: "b61uwr-3"
})(["display:flex;width:100%;font-size:1rem;align-items:center;height:100%;flex-direction:row;text-align:left;position:relative;"]);
var Label = styled.label.withConfig({
  displayName: "Checkboxstyles__Label",
  componentId: "b61uwr-4"
})(["position:relative;display:flex;flex:1 1 50%;align-items:", ";line-height:", ";flex-direction:column;cursor:pointer;border-radius:", ";&:not(:last-child){margin-bottom:", ";}.checkboxWrapper{border-radius:", ";width:100%;", "{padding:", ";margin:unset;}", "}"], function (props) {
  return props.hasLabel ? 'center' : '';
}, function (props) {
  return props.theme.font['line-height']['label-1'];
}, function (props) {
  return props.theme.size.border.radius.lg;
}, function (props) {
  return "".concat(props.optionBottomMargin, "px");
}, function (props) {
  return props.theme.size.border.radius.lg;
}, CheckboxOption, function (props) {
  return props.padding;
}, function (props) {
  return props.disabled && css(["cursor:default;color:", ";"], props.theme.color.monochrome.dark);
});
var LabelWrapper = styled.span.withConfig({
  displayName: "Checkboxstyles__LabelWrapper",
  componentId: "b61uwr-5"
})(["display:flex;flex-direction:column;margin-left:10px;user-select:none;flex:auto;width:100%;"]);
var LabelValue = styled.span.withConfig({
  displayName: "Checkboxstyles__LabelValue",
  componentId: "b61uwr-6"
})(["flex-grow:1;"]);
var RightHandWrapper = styled.div.withConfig({
  displayName: "Checkboxstyles__RightHandWrapper",
  componentId: "b61uwr-7"
})(["margin-right:", ";display:flex;align-self:flex-start;margin-top:2px;align-items:center;height:calc(100% - 30px);"], function (props) {
  return "".concat(props.rightPosition, "px");
});
var commonSquaresStyles = css(["", ""], function (props) {
  return css(["align-self:flex-start;margin-top:2px;fill:none;position:relative;width:", ";height:", ";max-width:", ";max-height:", ";flex:0 0 ", ";border-radius:3px;border-color:transparent;top:0;background-color:", ";border-radius:3px;"], checkboxSize, checkboxSize, checkboxSize, checkboxSize, checkboxSize, props.theme.color.monochrome.white);
});
var Square = styled.div.withConfig({
  displayName: "Checkboxstyles__Square",
  componentId: "b61uwr-8"
})(["", ""], function (props) {
  return css(["", " box-shadow:0 0 0 1px ", ";border:1px solid ", ";", ":hover &{box-shadow:0 0 0 1px ", ";border:1px solid ", ";}"], commonSquaresStyles, props.theme.color.monochrome.base, props.theme.color.monochrome.base, Label, props.theme.color.monochrome.dark, props.theme.color.monochrome.dark);
});
var SquareError = styled.div.withConfig({
  displayName: "Checkboxstyles__SquareError",
  componentId: "b61uwr-9"
})(["", ""], function (props) {
  return css(["", " box-shadow:0 0 0 1px ", ";border:1px solid ", ";"], commonSquaresStyles, props.theme.color.semantic.error.base, props.theme.color.semantic.error.base);
});
var Checkbox = styled.input.withConfig({
  displayName: "Checkboxstyles__Checkbox",
  componentId: "b61uwr-10"
})(["", " ", " ", ""], function (props) {
  return css(["&:focus ~ .checkboxWrapper{outline:", " auto 5px;outline-offset:-4px;}&:checked ~ .checkboxWrapper{background-color:", ";", "{background-color:", ";fill:", ";border:1px solid ", ";box-shadow:0 0 0 1px ", ";", ":hover &{background-color:", ";box-shadow:0 0 0 1px ", ";border-color:", ";}}", "{background-color:", ";fill:", ";border:1px solid ", ";box-shadow:0 0 0 1px ", ";", ":hover &{background-color:", ";box-shadow:0 0 0 1px ", ";border-color:", ";}}}&:not(:checked) ~ .checkboxWrapper:hover{background-color:", ";}"], props.theme.color.palette['brand-1'], props.hasBackground && props.hasLabel && props.theme.color.palette['brand-1-light'], Square, props.theme.color.palette['brand-1'], props.theme.color.palette.white, props.theme.color.palette['brand-1'], props.theme.color.palette['brand-1'], Label, props.theme.color.palette['brand-1-dark'], props.theme.color.palette['brand-1-dark'], props.theme.color.palette['brand-1-dark'], SquareError, props.theme.color.semantic.error.base, props.theme.color.semantic.error.light, props.theme.color.semantic.error.base, props.theme.color.semantic.error.base, Square, props.theme.color.palette['brand-1-dark'], props.theme.color.palette['brand-1-dark'], props.theme.color.palette['brand-1-dark'], props.hasBackground && props.hasLabel && props.theme.color.monochrome.lighter);
}, function (props) {
  return props.disabled && css(["& ~ .checkboxWrapper{cursor:default;color:", ";", ",", "{border:1px solid ", ";box-shadow:0 0 0 1px ", ";}}&:checked ~ .checkboxWrapper{", ",", "{background-color:", ";fill:", ";border:1px solid ", ";box-shadow:0 0 0 1px ", ";", ":hover &{background-color:", ";box-shadow:0 0 0 1px ", ";border-color:", ";}}}"], props.theme.color.monochrome.dark, Square, SquareError, props.theme.color.monochrome.base, props.theme.color.monochrome.base, Square, SquareError, props.theme.color.monochrome.base, props.theme.color.monochrome.white, props.theme.color.monochrome.base, props.theme.color.monochrome.base, Label, props.theme.color.monochrome.base, props.theme.color.monochrome.base, props.theme.color.monochrome.base);
}, function (props) {
  return props.hasLabel && css(["&:disabled ~ .checkboxWrapper{background-color:", ";&:hover{background-color:", ";}}"], props.theme.color.monochrome.lighter, props.theme.color.monochrome.lighter);
});
export { Square, SquareError, ContentContainer, FieldSet, Label, LabelWrapper, LabelValue, Checkbox, CheckboxList, CheckboxOption, RightHandWrapper };